var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"org-container"},[_c('el-button',{attrs:{"type":"success"},on:{"click":_vm.syncChinaRegion}},[_vm._v("同步全国省市区")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }